// components/common/dialogs/rejections/RejectAppointments.jsx
import { Button, CircularProgress, DialogContent, DialogTitle, IconButton, Paper, Stack, Typography, Alert, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Chip } from "@mui/material";
import { refresher } from "../../../../redux/guest-slices/other.slice";
import { useDispatch, useSelector } from "react-redux";
import InputFieldB from "../../../ui/InputFieldB";
import Icons from "../../../../assets/js/Icons";
import { useRef, useState } from "react";
import moment from "moment-timezone";
import { handleRejectAllAppointments } from "../../../../redux/specialist-slices/scheduleSlots.slice";

function RejectAppointments({ handleClose }) {
  const input = useRef("");
  const [helperText, setHelperText] = useState({});
  const dispatch = useDispatch();
  const { data, loadings } = useSelector((state) => state.otherSlice);
  const userTimeZone = data?.userTimeZone;
  const formatDate = (date) => {
    return moment(date).tz(userTimeZone).format("MMM DD, YYYY");
  };
  const formatTime = (timeStr) => {
    if (!timeStr) return "";

    return moment(timeStr)
      .tz(userTimeZone)
      .format("hh:mm A");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (input?.current?.value?.trim() === "") {
      return setHelperText({ reason: ["This field is required."] });
    }

    setHelperText({});
    const { success } =
      (await dispatch(
        handleRejectAllAppointments({
          day: data?.selectedDay,
          rejectReason: input?.current?.value,
        })
      ).unwrap()) || {};

    if (success) {
      setTimeout(() => {
        handleClose();
        dispatch(refresher());
      }, 500);
    }
  };

  return (
    <Paper>
      <DialogTitle sx={{ position: "relative" }}>
        <Typography variant="dialogTitle">
          Booked Appointments for {data?.selectedDay}
        </Typography>
        <IconButton size="small" variant="dialogCloseBtn" onClick={handleClose}>
          <Icons.Cross />
        </IconButton>
      </DialogTitle>
      <DialogContent
        dividers
        className="relative"
        sx={{
          ".MuiInputBase-root": { borderRadius: "6px" },
          textarea: { resize: "none" },
        }}
      >
        <Stack spacing={2}>
          <Alert severity="warning">
            You must reject all booked appointments before editing the time
            slots. Provide a rejection reason below and click "Reject All
            Appointments" to proceed.
          </Alert>

          <TableContainer component={Paper} variant="outlined">  
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: "grey.100" }}>
                  <TableCell sx={{ fontWeight: 600 }}>Member Name</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>
                    Appointment Date
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Start Time</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>End Time</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.appointments?.map((booking, index) => (
                  <TableRow key={index} hover>
                    <TableCell>
                      <Stack>
                        <Typography fontWeight={500}>
                          {booking.memberName}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {booking.memberEmail}
                        </Typography>
                      </Stack>
                    </TableCell>
                    <TableCell>{formatDate(booking.startTime)}</TableCell>
                    <TableCell>{formatTime(booking.startTime)}</TableCell>
                    <TableCell>{formatTime(booking.endTime)}</TableCell>
                    <TableCell>
                      <Chip
                        label="BOOKED"
                        color="error"
                        size="small"
                        sx={{ fontWeight: 600 }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box>
            <Typography variant="body2" color="text.secondary">
              Total Booked Appointments:{" "}
              <strong>{data?.appointments?.length || 0}</strong>
            </Typography>
          </Box>

          <Stack spacing={2} component="form" onSubmit={handleSubmit}>
            <InputFieldB
              name="reason"
              label="Rejection Reason *"
              inputRef={input}
              type="textarea"
              inputtype="InputFieldB"
              helperText={helperText}
              placeholder="Please provide a reason for rejecting these appointments "
            />

            <Button
              fullWidth
              type="submit"
              color="error"
              variant="contained"
              disabled={loadings?.reject}
              endIcon={
                loadings?.reject && (
                  <CircularProgress size={22} color="text" thickness={6} />
                )
              }
            >
              Reject All Appointments
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Paper>
  );
}

export default RejectAppointments;